import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SiteFooter"] */ "/app/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/app/components/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OnboardingGuard"] */ "/app/components/OnboardingGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/components/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ServiceWorkerRegistration.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\",\"800\"],\"display\":\"swap\"}],\"variableName\":\"poppins\"}");
